<template>
  <div id="app">
    <div class="title">
      意见反馈
    </div>
    <div class="feedback">
      <textarea v-model="cnt"  placeholder="请填写意见问题" class="content"></textarea>
    </div>
    <button @click="submit" class="feedback-btn">
      提交
    </button>
  </div>
</template>
<style scoped src="../../../static/css/Common.css"></style>
<style scoped src="../../../static/css/Feedback.css"></style>

<script>
import {feedbackApi} from '@/service/allApi'
export default {
  data(){
    return {
      cnt:""
    }
  },
  mounted(){

  },
  methods:{
    async submit(){
     
      if(this.cnt == ""){
        this.$message.warning("请填写你的反馈意见")
        return
      }
      const options = {
        cnt:this.cnt
      }
     
      const res = await feedbackApi(options)
       
      if(res.data.code == 100){
        alert("感谢您的宝贵意见，我们将第一时间处理您提出的问题")
        this.cnt = ""
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/iframe/Feedback.vue